/**
 * Algolia — Force "Most Popular" sort for autocomplete product suggestions
 *
 * The Algolia Shopify plugin bundles its own search client, so we intercept
 * at the fetch level to rewrite the index name in outgoing Algolia API
 * requests from "shopify_products" to the "most popular" replica.
 */
(function forcePopularAutocomplete() {
  var POPULAR_INDEX = 'shopify_products_recently_ordered_count_desc';
  var DEFAULT_INDEX = 'shopify_products';

  function rewriteBody(bodyStr) {
    try {
      var body = JSON.parse(bodyStr);
      if (body.requests && Array.isArray(body.requests)) {
        var changed = false;
        body.requests.forEach(function (req) {
          if (req.indexName === DEFAULT_INDEX) {
            req.indexName = POPULAR_INDEX;
            changed = true;
          }
        });
        if (changed) return JSON.stringify(body);
      }
    } catch (e) {}
    return null;
  }

  // Intercept fetch
  var origFetch = window.fetch;
  window.fetch = function (url, options) {
    if (options && options.body && typeof url === 'string' && url.indexOf('algolia') !== -1) {
      var rewritten = rewriteBody(options.body);
      if (rewritten) {
        options = Object.assign({}, options, { body: rewritten });
      }
    }
    return origFetch.call(this, url, options);
  };

  // Intercept XMLHttpRequest
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function () {
    this._algoliaUrl = (typeof arguments[1] === 'string' && arguments[1].indexOf('algolia') !== -1);
    return origXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (data) {
    if (this._algoliaUrl && typeof data === 'string') {
      var rewritten = rewriteBody(data);
      if (rewritten) data = rewritten;
    }
    return origXHRSend.call(this, data);
  };
})();

/**
 * Algolia Search — Disable Native Search AJAX
 *
 * When Algolia autocomplete is active, prevent the native Warehouse
 * SearchBar from firing its own AJAX search requests. The Algolia app
 * embed attaches to the same search input and renders its own dropdown,
 * so we hide the native results container and stop its input handler.
 */
(function disableNativeSearchForAlgolia() {
  function init() {
    // Algolia autocomplete adds .aa-Autocomplete or injects an .aa-Panel
    var algoliaActive = document.querySelector('.aa-Autocomplete, .aa-DetachedContainer, [class*="aa-"]');
    if (!algoliaActive) return;

    // Hide the native search results container so it never shows
    var nativeResults = document.querySelectorAll('.search-bar__results');
    nativeResults.forEach(function (el) {
      el.style.display = 'none';
    });

    // Set placeholder on the Algolia input to match the native search bar
    var aaInput = document.querySelector('.aa-Input');
    if (aaInput && !aaInput.placeholder) {
      aaInput.setAttribute('placeholder', 'Search here...');
    }

    // Intercept input events on the search field to prevent the native
    // _doSearch handler from firing AJAX requests
    var searchInputs = document.querySelectorAll('.search-bar__input');
    searchInputs.forEach(function (input) {
      input.addEventListener('input', function (e) {
        e.stopImmediatePropagation();
      }, true);
    });
  }

  // Run after DOM is ready and again after a short delay to catch
  // Algolia scripts that load asynchronously
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      setTimeout(init, 2000);
    });
  } else {
    init();
    setTimeout(init, 2000);
  }
})();

/**
 * Algolia Search — RFQ Labels, B2B Pricing & Stock Status
 *
 * Uses Algolia's custom hook system to override product card templates
 * in both the autocomplete dropdown and the InstantSearch results page.
 *
 * The rfq_only metafield is indexed directly in Algolia, so we read
 * hit.meta.custom.rfq_only without any additional API calls.
 *
 * For RFQ products (rfq_only === "No"), we show "Request a Quote"
 * instead of a price. For normal products, we include BSS B2B
 * data attributes so wholesale pricing overrides work.
 *
 * Stock/inventory status is omitted from templates entirely since
 * the client does not manage inventory.
 *
 * PREIS-153: non-RFQ products where every variant is $0 (brochures)
 * render no price element at all, for all users.
 */
(function algoliaCustomHooks() {
  function isRfqProduct(hit) {
    return hit.meta && hit.meta.custom &&
      typeof hit.meta.custom.rfq_only === 'string' &&
      hit.meta.custom.rfq_only.toLowerCase().indexOf('no') !== -1;
  }

  // PREIS-153 — Brochure products have a $0 price and must render no price
  // element at all. Hide only when the MAX variant price is 0 (i.e. every
  // variant is free); mixed-price products keep their price. Callers gate
  // this behind !rfq: RFQ products may carry $0 placeholder prices but must
  // keep the bss-price-element pattern so custom.js can reveal B2B contract
  // pricing. Prices are numbers in dollars on Algolia hits — fall back from
  // variants_max_price to price, and default to "not zero" (price shows)
  // when neither is parseable, so a missing field can never hide a real price.
  function isZeroPriceProduct(hit) {
    var candidates = [hit.variants_max_price, hit.price];
    for (var i = 0; i < candidates.length; i++) {
      var value = parseFloat(candidates[i]);
      if (!isNaN(value)) {
        return value === 0;
      }
    }
    return false;
  }

  // BSS can give any signed-in customer an RFQ contract price, not just B2B accounts.
  function isSignedIn() {
    return !!(window.theme && window.theme.customer && window.theme.customer.id);
  }

  document.addEventListener('algolia.hooks.initialize', function () {

    // Force "Most Popular" as the default sort index (InstantSearch results page)
    algoliaShopify.hooks.registerHook(
      'beforeInstantSearchOptions',
      function (options) {
        options.indexName = 'shopify_products_recently_ordered_count_desc';
        return options;
      }
    );

    // Disable full-screen "detached" mode on mobile — show inline dropdown instead
    algoliaShopify.hooks.registerHook(
      'beforeAutocompleteOptions',
      function (options) {
        options.detachedMediaQuery = 'none';
        return options;
      }
    );


    // InstantSearch results page — product card template
    algoliaShopify.hooks.registerHook(
      'beforeInstantSearchProductTemplate',
      function (_defaultTemplate, hit, html, components) {
        var rfq = isRfqProduct(hit);
        var omitPrice = rfq ? !isSignedIn() : isZeroPriceProduct(hit);

        var rfqLabel = rfq
          ? html`<div class="algolia-rfq-label rfq-element" data-rfq-product="${hit.id}">Request a Quote</div>`
          : '';

        // No element at all, not a hidden one, so neither BSS nor custom.js can reveal a price.
        var priceEl = omitPrice
          ? ''
          : html`<div class="ais-hit--price ${rfq ? 'bss-price-element' : ''}"
                      data-variant-id="${hit.objectID}"
                      bss-b2b-product-id="${hit.id}"
                      bss-b2b-product-price=""
                      style="${rfq ? 'display: none;' : ''}">
                   ${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}
                 </div>`;

        var skuEl = hit.sku
          ? html`<div class="ais-hit--sku">ITEM: ${hit.sku}</div>`
          : '';

        return html`
          <div class="ais-hit ais-product"
               onClick="${function () { algoliaShopify.helpers.handleItemClick(hit); }}">
            <a href="/products/${hit.handle}">
              <img class="ais-hit--image"
                   src="${algoliaShopify.helpers.mediumImage(hit)}"
                   alt="${hit.title}" />
            </a>
            <a class="ais-hit--title" href="/products/${hit.handle}">
              ${components.Highlight({ attribute: 'title', hit: hit })}
            </a>
            ${skuEl}
            ${rfqLabel}
            ${priceEl}
          </div>
        `;
      }
    );

    // Autocomplete dropdown — product suggestion template
    // NOTE: The autocomplete hook signature differs from InstantSearch.
    // It does NOT receive html/components — templates are HTML strings.
    algoliaShopify.hooks.registerHook(
      'beforeAutocompleteProductTemplate',
      function (_defaultTemplate, params) {
        var hit = params.item;
        var html = params.html;
        var components = params.components;
        var rfq = isRfqProduct(hit);
        var omitPrice = rfq ? !isSignedIn() : isZeroPriceProduct(hit);

        var rfqLabel = rfq
          ? html`<div class="algolia-rfq-label rfq-element" data-rfq-product="${hit.id}">Request a Quote</div>`
          : '';

        var priceEl = omitPrice
          ? ''
          : html`<div class="aa-ItemContentPrice">
                   <div class="aa-ItemContentPriceCurrent ${rfq ? 'bss-price-element' : ''}"
                        data-variant-id="${hit.objectID}"
                        bss-b2b-product-id="${hit.id}"
                        bss-b2b-product-price=""
                        style="${rfq ? 'display: none;' : ''}">
                     ${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}
                   </div>
                 </div>`;

        var variantLabel = hit.variant_title
          ? html`<span class="algolia-variant">${' ( ' + hit.variant_title + ' )'}</span>`
          : '';

        var skuEl = hit.sku
          ? html`<div class="aa-ItemContentSku">ITEM: ${hit.sku}</div>`
          : '';

        return html`
          <a class="aa-ItemLink aa-ProductItem" href="/products/${hit.handle}/"
             onClick="${function () { algoliaShopify.helpers.handleItemClick(hit); }}">
            <div class="aa-ItemContent">
              <div class="aa-ItemPicture aa-ItemPicture--loaded">
                <img src="${algoliaShopify.helpers.mediumImage(hit)}"
                     alt="${hit.title}" />
              </div>
              <div class="aa-ItemContentBody">
                <div class="aa-ItemContentTitleWrapper">
                  <div class="aa-ItemContentTitle">
                    ${components.Highlight({ hit: hit, attribute: 'title' })}
                    ${variantLabel}
                  </div>
                </div>
                ${skuEl}
                ${rfqLabel}
                ${priceEl}
              </div>
            </div>
          </a>
        `;
      }
    );
  });
})();

/**
 * Force "Most popular" sort on the search page.
 * Algolia defaults to Relevance when no sortBy param is in the URL,
 * so we add it before Algolia initializes.
 */
(function forcePopularSort() {
  if (window.location.pathname === '/search' && !window.location.search.includes('sortBy=')) {
    var url = new URL(window.location);
    url.searchParams.set('sortBy', 'shopify_products_recently_ordered_count_desc');
    window.history.replaceState(null, '', url.toString());
  }

  // Also remove the Relevance option from the dropdown
  var observer = new MutationObserver(function () {
    var select = document.querySelector('.ais-SortBy-select');
    if (!select) return;
    var relevanceOption = select.querySelector('option[value="shopify_products"]');
    if (relevanceOption) {
      relevanceOption.remove();
      observer.disconnect();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
